module.exports = __webpack_public_path__ + "assets/img/715885517b80cbfeaca271426e1d866e.svg";